import { ArrowsAltOutlined, EllipsisOutlined, SearchOutlined, ShrinkOutlined } from "@ant-design/icons";
import { Button, Card, Dropdown, Input, InputRef, Modal, Space, Table, TableColumnType, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import SVGIcon from "../../../../utils/SVGIcon";
import Config from "../../../../config/Config";
import { useAppDispatch, useAppSelector } from "../../../../utils/hooks/hooks";
import { fetchUserList } from "../utils/slice";
import { FilterDropdownProps } from "antd/es/table/interface";
import { renderNA } from "../../../../utils/commonFunctions";
const { Paragraph, Text } = Typography;

const UserDetailsModal = ({ graphModalObject, filterdData, graphModal, setGraphModal, setIsLoading }: any) => {
    // const [graphModal, setGraphModal] = useState(false);
    const dispatch = useAppDispatch();
    const [userList, setUserList] = useState([]);
    const userDetails = useAppDispatch();



    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<InputRef>(null);

    const handleSearch = (
        selectedKeys: string[],
        confirm: FilterDropdownProps['confirm'],
        dataIndex: any,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    useEffect(() => {
        console.log(graphModalObject)
        if (graphModalObject) {
            let requestData = {
                ...filterdData,
                ...{ graph_type: graphModalObject.graph_key },
            }
            // console.log(graphModalId, requestData)
            setIsLoading(true)
            dispatch(fetchUserList(requestData))
                .then((response: any) => {
                    setIsLoading(false)
                    console.log('response', response)
                    setUserList(response.rows);
                    setGraphModal(true)
                }).catch((error: any) => error);

        }
        else {
            setUserList([]);
        }

    }, [graphModalObject])

    const getColumnSearchProps = (dataIndex: any, title: any): TableColumnType => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${title}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button
                        type="default"
                        size="large"
                        onClick={() => {
                            clearFilters && clearFilters();
                            setSearchText('');
                            confirm({ closeDropdown: false });
                            close();
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Reset
                    </Button>


                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
        ),
        onFilter: (value, record) => {
            if (value == 'N/A') {
                return record[dataIndex] == null;
            }
            return record[dataIndex] ?
                record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes((value as string).toLowerCase()) :
                false

        },
        filterDropdownProps: {
            onOpenChange(open) {
                if (open) {
                    setTimeout(() => searchInput.current?.select(), 100);
                }
            },
        },
    });


    const columns: any[] = [
        {
            title: "ID",
            key: 'id',
            fixed: true,
            width: 40,
            sorter: (a: any, b: any) => a.id - b.id,
            render: (item: any) => item.id,
        },
        {
            title: "First Name",
            key: 'name',
            width: 60,
            field: "name",
            ...getColumnSearchProps('name', 'First Name'),
            render: (item: any) => renderNA(item.name),
        },
        {
            title: "Last Name",
            key: 'last_name',
            width: 60,
            field: "last_name",
            ...getColumnSearchProps('last_name', 'Last Name'),
            render: (item: any) => renderNA(item.last_name),
        },
        {
            title: "Email",
            key: 'email',
            width: 100,
            field: "email",
            ...getColumnSearchProps('email', 'Email'),
            render: (item: any) => renderNA(item.email),
        },
        {
            title: "Company Name",
            key: 'company_name',
            width: 100,
            field: "company_name",
            ...getColumnSearchProps('company_name', 'Company Name'),
            render: (item: any) => renderNA(item.company_name),
        },
        {
            title: "Industry Name",
            key: 'industry_name',
            width: 100,
            field: "industry_name",
            ...getColumnSearchProps('industry_name', 'Industry Name'),
            render: (item: any) => renderNA(item.industry_name),
        },
        {
            title: graphModalObject?.title || '',
            key: 'graph_value',
            width: 150,
            field: "graph_value",
            ...getColumnSearchProps('graph_value', graphModalObject?.title || ''),
            render: (item: any) => <Paragraph
                ellipsis={{
                    rows: 2,
                    expandable: 'collapsible',
                    symbol: ((expanded: boolean) => expanded ? 'Read less' : 'Read more')
                }}>
                {renderNA(item.graph_value)}
            </Paragraph>
            ,
        },


        // xxl={{ span: 8 }} lg={{ span: 12 }} md={{ span: 24 }}
        // xxl={{ span: 6 }} lg={{ span: 10 }} md={{ span: 22 }}
    ];

    const columnsLocation: any[] = [...columns.slice(0, -1),
    {
        title: 'Zipcode',
        key: 'graph_value',
        width: 60,
        field: "graph_value",
        ...getColumnSearchProps('graph_value', 'Zipcode'),
        render: (item: any) => <Paragraph
            ellipsis={{
                rows: 2,
                expandable: 'collapsible',
                symbol: ((expanded: boolean) => expanded ? 'Read less' : 'Read more')
            }}>
            {renderNA(item.graph_value)}
        </Paragraph>
        ,
    },
    {
        title: 'State',
        key: 'state',
        width: 80,
        field: "state",
        ...getColumnSearchProps('state', 'State'),
        render: (item: any) => <Paragraph
            ellipsis={{
                rows: 2,
                expandable: 'collapsible',
                symbol: ((expanded: boolean) => expanded ? 'Read less' : 'Read more')
            }}>
            {renderNA(item.state)}
        </Paragraph>
        ,
    },
    {
        title: 'City',
        key: 'city',
        width: 80,
        field: "city",
        ...getColumnSearchProps('city', 'City'),
        render: (item: any) => <Paragraph
            ellipsis={{
                rows: 2,
                expandable: 'collapsible',
                symbol: ((expanded: boolean) => expanded ? 'Read less' : 'Read more')
            }}>
            {renderNA(item.city)}
        </Paragraph>
        ,
    },
    ];
    return <>
        <Modal
            title={`${graphModalObject && graphModalObject.title} Users List`}
            open={graphModal}
            width={"65%"}
            onCancel={() => setGraphModal(false)}
            destroyOnHidden
            centered
            closeIcon={<SVGIcon icon="close" color={Config.themePrimaryBtn} />}
            footer={false}
        // footer={[
        //   <CancelButton key={2} onClick={()=>console.log('close')} />,
        //   <SaveButton
        //     key={1}
        //     form="editForm"
        //     disabled={false}
        //     loading={false}
        //   />,
        // ]}
        // onOk={handleOk}
        // onCancel={handleCancel}
        >


            <Table
                // title={() => <span style={{ fontWeight: 600, fontSize: 16 }}>{'Careers'}</span>}
                dataSource={userList || []}
                // dataSource={chart_js_data?.careers?.filter((item: any, index: number) => item.total > 0) || []}
                // columns={{ ...columns,{...graphModalObject?.title === 'Location' ? {columnsLocation} : {}})}}
                columns={graphModalObject?.key === 'zip_code' ? columnsLocation : columns}
                pagination={{ defaultPageSize: 8, showSizeChanger: false, position: ['none', 'bottomCenter'] }}
                // pagination={ }
                scroll={{ x: 310 }}
            // bordered


            />
        </Modal>
    </>
}


export default UserDetailsModal;